import React from "react";

const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Renders `text`, wrapping every case-insensitive occurrence of `highlight` in <strong>.
 * The escaped form is only ever used to build the split pattern — matched parts are
 * compared against the raw `highlight`, since the captured text never contains the
 * backslashes the pattern needed.
 */
export const HighlightedText = ({text, highlight}) => {
    const needle = highlight?.trim();
    if (!needle) return <span>{text}</span>;

    const parts = text.split(new RegExp(`(${escapeRegExp(needle)})`, 'gi'));
    const normalizedHighlight = needle.toLowerCase();

    return (
        <>
            {parts.map((part, index) =>
                part.toLowerCase() === normalizedHighlight ? (
                    <strong key={index}>{part}</strong>
                ) : (
                    <span key={index}>{part}</span>
                )
            )}
        </>
    );
};
